import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { isString } from 'lodash';

import 'vdp-used/components/WarrantiesAndPolicies/WarrantiesAndPolicies.scss';

const WarrantyClass = ({ warrantyClassText }) => {
    if (!isString(warrantyClassText) || warrantyClassText === '') {
        return null;
    }
    return (
        <div className="vdp-information__warranty-wrapper">
            <p className="vdp-information__subtitle sr-text is-bold">{LocaleService.t('VDP_USED.WARRANTY.CLASS')}</p>
            <p className="vdp-information__secondary-text">{warrantyClassText}</p>
        </div>
    );
};

WarrantyClass.defaultProps = {
    warrantyClassText: '',
};
WarrantyClass.propTypes = {
    warrantyClassText: PropTypes.string,
};

WarrantyClass.displayName = 'WarrantyClass';

export default WarrantyClass;
